export const phaseStates = {
  AWAITING: 1,
  INROUTE: 2,
  INPROCESS: 3,
  DONE: 4,
};
